import PocketBase from 'pocketbase';

export const pb = new PocketBase(process.env.REACT_APP_PB_URL || 'http://localhost:8090'); // Default to localhost:8090 if not set

export async function loginPocketBase(email, password) {
  return await pb.collection('users').authWithPassword(email, password);
}

export async function logoutPocketBase() {
  pb.authStore.clear();
  return true;
}

export async function updatePocketBaseProfile(userId, data) {
  return await pb.collection('users').update(userId, data);
}
